import React from 'react';
import { Link, useLocation, Outlet, useNavigate } from 'react-router-dom';
import { Home, Building2, Newspaper, Settings, ArrowLeft, Layout, Key, LogOut, Info, Layers, ImageIcon, Mail } from 'lucide-react';
import { meshLightingInfo } from '../../data/mock';
import { authApi } from '../../services/api';

const AdminLayout = ({ onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: '/admin', label: 'Dashboard', icon: Home, exact: true },
    { path: '/admin/landing-page', label: 'Landing Page', icon: Layout },
    { path: '/admin/about', label: 'About Page', icon: Info },
    { path: '/admin/company', label: 'Company Info', icon: Settings },
    { path: '/admin/brands', label: 'Brands', icon: Building2 },
    { path: '/admin/sectors', label: 'Sectors', icon: Layers },
    { path: '/admin/news', label: 'Mesh News', icon: Newspaper },
    { path: '/admin/media', label: 'Media Library', icon: ImageIcon },
    { path: '/admin/contacts', label: 'Contact Submissions', icon: Mail },
  ];

  const isActive = (path, exact = false) => {
    if (exact) return location.pathname === path;
    return location.pathname.startsWith(path);
  };

  const handleLogout = async () => {
    try {
      await authApi.logout();
    } catch (err) {
      console.error('Logout error:', err);
    }
    onLogout();
    navigate('/admin');
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Sidebar */}
      <aside className="fixed inset-y-0 left-0 w-64 bg-gray-900 text-white">
        <div className="p-6">
          <Link to="/admin" className="flex items-center space-x-3">
            <img
              src={meshLightingInfo.logo}
              alt="Mesh Lighting"
              className="h-8 w-auto brightness-0 invert"
            />
          </Link>
          <p className="text-xs text-gray-400 mt-2">Content Management</p>
        </div>

        <nav className="px-4 space-y-1">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center px-4 py-3 rounded-lg transition-colors ${
                isActive(item.path, item.exact)
                  ? 'bg-gray-800 text-white'
                  : 'text-gray-400 hover:bg-gray-800 hover:text-white'
              }`}
            >
              <item.icon className="h-5 w-5 mr-3" />
              {item.label}
            </Link>
          ))}
        </nav>

        {/* Bottom Section */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-800">
          <Link
            to="/admin/change-password"
            className={`flex items-center px-4 py-3 rounded-lg transition-colors ${
              location.pathname === '/admin/change-password'
                ? 'bg-gray-800 text-white'
                : 'text-gray-400 hover:bg-gray-800 hover:text-white'
            }`}
          >
            <Key className="h-5 w-5 mr-3" />
            Change Password
          </Link>
          <button
            onClick={handleLogout}
            className="w-full flex items-center px-4 py-3 text-gray-400 hover:bg-gray-800 hover:text-white rounded-lg transition-colors"
          >
            <LogOut className="h-5 w-5 mr-3" />
            Logout
          </button>
          <Link
            to="/"
            className="flex items-center px-4 py-3 text-gray-400 hover:text-white transition-colors mt-2"
          >
            <ArrowLeft className="h-5 w-5 mr-3" />
            Back to Website
          </Link>
        </div>
      </aside>

      {/* Main Content */}
      <main className="ml-64 p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
